import { useMemo } from 'react';

export const emailValidator = (message?: string) => (value: string) =>
  /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value) || message || false;

const useEmailValidator = (message?: string) => {
  return useMemo(() => emailValidator(message), [message]);
};
export default useEmailValidator;
